export default __webpack_public_path__ + "static/IN-9008-vs-IN-5907_resTestBig-7a60f5cd1361ea64a2d911a8a5736eb7.webp";